export const ACCOUNT_REPORT_STATUSES = [
    { id: 1, label: 'Em Análise', color: 'info' as const },
    { id: 2, label: 'Aprovada', color: 'success' as const },
    { id: 3, label: 'Reprovada', color: 'error' as const },
    { id: 4, label: 'Pendente de Documento', color: 'warning' as const },
];

export function getAccountReportStatus(id?: number) {
    return ACCOUNT_REPORT_STATUSES.find((s) => s.id === id);
}
